/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { VicnamesFeatureSearchOptions } from '../../models/vicnames-feature-search-options';

export interface NormalSearchVicnamesFeaturesOptions$Params {}

export function normalSearchVicnamesFeaturesOptions(
  http: HttpClient,
  rootUrl: string,
  params?: NormalSearchVicnamesFeaturesOptions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<VicnamesFeatureSearchOptions>> {
  const rb = new RequestBuilder(
    rootUrl,
    normalSearchVicnamesFeaturesOptions.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VicnamesFeatureSearchOptions>;
      }),
    );
}

normalSearchVicnamesFeaturesOptions.PATH = '/vicnames/search/options';
